var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g4, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 146,
    viewBox: "0 0 143 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_4882)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.2412,
    y: 11.4285,
    width: 73.8073,
    height: 73.8073,
    rx: 4,
    fill: "url(#paint0_linear_2_4882)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_2_4882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5409 10.4451C10.0166 17.0504 6.83963 30.9361 13.4461 41.4597C20.0525 51.9834 33.9349 55.1599 44.4591 48.5545C54.9834 41.9492 58.1604 28.0636 51.5539 17.5399C44.9475 7.01674 31.0651 3.84027 20.5409 10.4451Z",
    fill: "url(#paint1_radial_2_4882)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2_4882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 128C99.475 128 109.772 124.464 109.772 120.103V114.896H63.7725V120.103C63.7725 124.464 74.0699 128 86.7725 128Z",
    fill: "url(#paint2_radial_2_4882)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 122.792C99.475 122.792 109.772 119.257 109.772 114.896C109.772 110.535 99.475 107 86.7725 107C74.0699 107 63.7725 110.535 63.7725 114.896C63.7725 119.257 74.0699 122.792 86.7725 122.792Z",
    fill: "url(#paint3_linear_2_4882)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 114.896C105.921 115.738 105.423 116.562 104.469 117.334C103.515 118.106 102.123 118.809 100.386 119.404C96.9117 120.593 92.099 121.332 86.7728 121.332C81.4467 121.332 76.6339 120.593 73.1601 119.404C71.4224 118.809 70.0305 118.106 69.0766 117.334C68.1225 116.562 67.6245 115.738 67.6245 114.896C67.6245 114.053 68.1225 113.229 69.0766 112.457C70.0305 111.685 71.4224 110.982 73.1601 110.387C76.6339 109.199 81.4467 108.46 86.7728 108.46C92.099 108.46 96.9117 109.199 100.386 110.388C102.123 110.982 103.515 111.686 104.469 112.457C105.423 113.229 105.921 114.054 105.921 114.896V114.896Z",
    stroke: "url(#paint4_linear_2_4882)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 114.811C98.7212 115.016 99.4141 115.215 100.121 115.419C100.028 115.438 99.9745 115.45 99.9182 115.46C95.5979 116.214 91.2749 116.968 86.9546 117.723C86.8335 117.744 86.7462 117.748 86.6223 117.726C82.2936 116.967 77.9593 116.209 73.6278 115.45C73.5827 115.442 73.5377 115.434 73.4307 115.413C73.6053 115.366 73.7658 115.327 73.9123 115.284C74.3488 115.152 74.7853 115.02 75.2106 114.885C75.3317 114.846 75.419 114.842 75.5767 114.869C79.2379 115.503 82.9048 116.135 86.566 116.769C86.7434 116.799 86.8645 116.798 87.0391 116.768C90.644 116.123 94.2546 115.48 97.8651 114.837C97.9299 114.825 97.9975 114.814 98.0087 114.811Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 113.422C77.5479 113.536 78.1646 113.644 78.7842 113.753C81.3921 114.212 84.0029 114.672 86.608 115.132C86.7657 115.161 86.8783 115.162 87.0417 115.133C90.1453 114.58 93.2573 114.03 96.3665 113.479C96.4566 113.463 96.5496 113.448 96.6763 113.426C96.6763 113.507 96.6763 113.578 96.6763 113.65C96.6763 113.872 96.6735 114.094 96.6791 114.316C96.682 114.358 96.6453 114.382 96.5214 114.404C93.3305 114.963 90.1396 115.524 86.9516 116.085C86.8417 116.104 86.7685 116.103 86.6615 116.084C83.465 115.528 80.2656 114.973 77.0691 114.416C76.9959 114.403 76.9057 114.373 76.9057 114.352C76.8945 114.046 76.8973 113.74 76.8973 113.422Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 113.391C83.3808 112.915 86.0619 112.443 88.7769 111.966C88.7853 111.999 88.7966 112.023 88.7994 112.047C88.8163 112.238 88.8388 112.43 88.8445 112.622C88.8445 112.646 88.7853 112.68 88.7177 112.692C86.7491 113.041 84.7777 113.387 82.8063 113.732C82.7443 113.742 82.6345 113.747 82.581 113.738C81.9473 113.625 81.3249 113.51 80.6743 113.391Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 113.188C90.0807 113.422 90.0835 113.639 90.075 113.857C90.075 113.876 90.0074 113.903 89.9455 113.914C88.9288 114.094 87.9093 114.272 86.887 114.45C86.8363 114.459 86.7433 114.465 86.7011 114.457C86.0618 114.346 85.4281 114.232 84.7578 114.112C86.5349 113.804 88.281 113.5 90.0807 113.188Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 120C99.475 120 109.772 116.464 109.772 112.103V106.896H63.7725V112.103C63.7725 116.464 74.0699 120 86.7725 120Z",
    fill: "url(#paint5_radial_2_4882)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 114.792C99.475 114.792 109.772 111.257 109.772 106.896C109.772 102.535 99.475 98.9998 86.7725 98.9998C74.0699 98.9998 63.7725 102.535 63.7725 106.896C63.7725 111.257 74.0699 114.792 86.7725 114.792Z",
    fill: "url(#paint6_linear_2_4882)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 106.896C105.921 107.738 105.423 108.562 104.469 109.334C103.515 110.106 102.123 110.809 100.386 111.404C96.9117 112.593 92.099 113.332 86.7728 113.332C81.4467 113.332 76.6339 112.593 73.1601 111.404C71.4224 110.809 70.0305 110.106 69.0766 109.334C68.1225 108.562 67.6245 107.738 67.6245 106.896C67.6245 106.053 68.1225 105.229 69.0766 104.457C70.0305 103.685 71.4224 102.982 73.1601 102.387C76.6339 101.199 81.4467 100.46 86.7728 100.46C92.099 100.46 96.9117 101.199 100.386 102.388C102.123 102.982 103.515 103.686 104.469 104.457C105.423 105.229 105.921 106.054 105.921 106.896V106.896Z",
    stroke: "url(#paint7_linear_2_4882)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 106.811C98.7212 107.016 99.4141 107.215 100.121 107.419C100.028 107.438 99.9745 107.45 99.9182 107.46C95.5979 108.214 91.2749 108.968 86.9546 109.723C86.8335 109.744 86.7462 109.748 86.6223 109.726C82.2936 108.967 77.9593 108.209 73.6278 107.45C73.5827 107.442 73.5377 107.434 73.4307 107.413C73.6053 107.366 73.7658 107.327 73.9123 107.284C74.3488 107.152 74.7853 107.02 75.2106 106.885C75.3317 106.846 75.419 106.842 75.5767 106.869C79.2379 107.503 82.9048 108.135 86.566 108.769C86.7434 108.799 86.8645 108.798 87.0391 108.768C90.644 108.123 94.2546 107.48 97.8651 106.837C97.9299 106.825 97.9975 106.814 98.0087 106.811Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 105.422C77.5479 105.536 78.1646 105.644 78.7842 105.753C81.3921 106.212 84.0029 106.672 86.608 107.132C86.7657 107.161 86.8783 107.162 87.0417 107.133C90.1453 106.58 93.2573 106.03 96.3665 105.479C96.4566 105.463 96.5496 105.448 96.6763 105.426C96.6763 105.507 96.6763 105.578 96.6763 105.65C96.6763 105.872 96.6735 106.094 96.6791 106.316C96.682 106.358 96.6453 106.382 96.5214 106.404C93.3305 106.963 90.1396 107.524 86.9516 108.085C86.8417 108.104 86.7685 108.103 86.6615 108.084C83.465 107.528 80.2656 106.973 77.0691 106.416C76.9959 106.403 76.9057 106.373 76.9057 106.352C76.8945 106.046 76.8973 105.74 76.8973 105.422Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 105.391C83.3808 104.915 86.0619 104.443 88.7769 103.966C88.7853 103.999 88.7966 104.023 88.7994 104.047C88.8163 104.238 88.8388 104.43 88.8445 104.622C88.8445 104.646 88.7853 104.68 88.7177 104.692C86.7491 105.041 84.7777 105.387 82.8063 105.732C82.7443 105.742 82.6345 105.747 82.581 105.738C81.9473 105.625 81.3249 105.51 80.6743 105.391Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 105.188C90.0807 105.422 90.0835 105.639 90.075 105.857C90.075 105.876 90.0074 105.903 89.9455 105.914C88.9288 106.094 87.9093 106.272 86.887 106.45C86.8363 106.459 86.7433 106.465 86.7011 106.457C86.0618 106.346 85.4281 106.232 84.7578 106.112C86.5349 105.804 88.281 105.5 90.0807 105.188Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 112C99.475 112 109.772 108.464 109.772 104.103V98.8962H63.7725V104.103C63.7725 108.464 74.0699 112 86.7725 112Z",
    fill: "url(#paint8_radial_2_4882)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 106.792C99.475 106.792 109.772 103.257 109.772 98.8961C109.772 94.5351 99.475 90.9998 86.7725 90.9998C74.0699 90.9998 63.7725 94.5351 63.7725 98.8961C63.7725 103.257 74.0699 106.792 86.7725 106.792Z",
    fill: "url(#paint9_linear_2_4882)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 98.8958C105.921 99.738 105.423 100.562 104.469 101.334C103.515 102.106 102.123 102.809 100.386 103.404C96.9117 104.593 92.099 105.332 86.7728 105.332C81.4467 105.332 76.6339 104.593 73.1601 103.404C71.4224 102.809 70.0305 102.106 69.0766 101.334C68.1225 100.562 67.6245 99.738 67.6245 98.8958C67.6245 98.0535 68.1225 97.229 69.0766 96.4571C70.0305 95.6854 71.4224 94.982 73.1601 94.3873C76.6339 93.1986 81.4467 92.4597 86.7728 92.4597C92.099 92.4597 96.9117 93.1988 100.386 94.3876C102.123 94.9822 103.515 95.6856 104.469 96.4573C105.423 97.2294 105.921 98.0536 105.921 98.896V98.8958Z",
    stroke: "url(#paint10_linear_2_4882)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 98.811C98.7212 99.0161 99.4141 99.2152 100.121 99.4194C100.028 99.4382 99.9745 99.4502 99.9182 99.4596C95.5979 100.214 91.2749 100.968 86.9546 101.723C86.8335 101.744 86.7462 101.748 86.6223 101.726C82.2936 100.967 77.9593 100.209 73.6278 99.4502C73.5827 99.4425 73.5377 99.4339 73.4307 99.4134C73.6053 99.3664 73.7658 99.3271 73.9123 99.2835C74.3488 99.152 74.7853 99.0195 75.2106 98.8845C75.3317 98.8461 75.419 98.8418 75.5767 98.8691C79.2379 99.5031 82.9048 100.135 86.566 100.769C86.7434 100.799 86.8645 100.798 87.0391 100.768C90.644 100.123 94.2546 99.4801 97.8651 98.8367C97.9299 98.8247 97.9975 98.8136 98.0087 98.811Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 97.4219C77.5479 97.5364 78.1646 97.644 78.7842 97.7534C81.3921 98.2122 84.0029 98.6719 86.608 99.1325C86.7657 99.1607 86.8783 99.1624 87.0417 99.1333C90.1453 98.5805 93.2573 98.0302 96.3665 97.4791C96.4566 97.4629 96.5496 97.4475 96.6763 97.4261C96.6763 97.5073 96.6763 97.5782 96.6763 97.65C96.6763 97.8722 96.6735 98.0943 96.6791 98.3156C96.682 98.3583 96.6453 98.3823 96.5214 98.4045C93.3305 98.9633 90.1396 99.5238 86.9516 100.085C86.8417 100.104 86.7685 100.103 86.6615 100.084C83.465 99.5281 80.2656 98.9727 77.0691 98.4156C76.9959 98.4028 76.9057 98.3729 76.9057 98.3515C76.8945 98.0456 76.8973 97.7397 76.8973 97.4219Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 97.391C83.3808 96.9151 86.0619 96.4435 88.7769 95.9658C88.7853 95.9991 88.7966 96.0231 88.7994 96.047C88.8163 96.2384 88.8388 96.4298 88.8445 96.622C88.8445 96.646 88.7853 96.6801 88.7177 96.6921C86.7491 97.0407 84.7777 97.3868 82.8063 97.7319C82.7443 97.7422 82.6345 97.7473 82.581 97.7379C81.9473 97.6251 81.3249 97.5098 80.6743 97.391Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 97.1875C90.0807 97.4225 90.0835 97.6395 90.075 97.8565C90.075 97.8762 90.0074 97.9027 89.9455 97.9138C88.9288 98.0941 87.9093 98.2718 86.887 98.4495C86.8363 98.4589 86.7433 98.4649 86.7011 98.4572C86.0618 98.3461 85.4281 98.2316 84.7578 98.112C86.5349 97.8036 88.281 97.5002 90.0807 97.1875Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 104C99.475 104 109.772 100.464 109.772 96.1034V90.8962H63.7725V96.1034C63.7725 100.464 74.0699 104 86.7725 104Z",
    fill: "url(#paint11_radial_2_4882)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 98.7924C99.475 98.7924 109.772 95.2571 109.772 90.8961C109.772 86.5351 99.475 82.9998 86.7725 82.9998C74.0699 82.9998 63.7725 86.5351 63.7725 90.8961C63.7725 95.2571 74.0699 98.7924 86.7725 98.7924Z",
    fill: "url(#paint12_linear_2_4882)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 90.8958C105.921 91.738 105.423 92.5625 104.469 93.3344C103.515 94.1061 102.123 94.8095 100.386 95.4042C96.9117 96.5929 92.099 97.3319 86.7728 97.3319C81.4467 97.3319 76.6339 96.5929 73.1601 95.4042C71.4224 94.8095 70.0305 94.1061 69.0766 93.3344C68.1225 92.5625 67.6245 91.738 67.6245 90.8958C67.6245 90.0535 68.1225 89.229 69.0766 88.4571C70.0305 87.6854 71.4224 86.982 73.1601 86.3873C76.6339 85.1986 81.4467 84.4597 86.7728 84.4597C92.099 84.4597 96.9117 85.1988 100.386 86.3876C102.123 86.9822 103.515 87.6856 104.469 88.4573C105.423 89.2294 105.921 90.0536 105.921 90.896V90.8958Z",
    stroke: "url(#paint13_linear_2_4882)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 90.811C98.7212 91.0161 99.4141 91.2152 100.121 91.4194C100.028 91.4382 99.9745 91.4502 99.9182 91.4596C95.5979 92.214 91.2749 92.9676 86.9546 93.723C86.8335 93.7443 86.7462 93.7477 86.6223 93.7255C82.2936 92.9668 77.9593 92.2089 73.6278 91.4502C73.5827 91.4425 73.5377 91.4339 73.4307 91.4134C73.6053 91.3664 73.7658 91.3271 73.9123 91.2835C74.3488 91.152 74.7853 91.0195 75.2106 90.8845C75.3317 90.8461 75.419 90.8418 75.5767 90.8691C79.2379 91.5031 82.9048 92.1346 86.566 92.7686C86.7434 92.7993 86.8645 92.7985 87.0391 92.7677C90.644 92.1226 94.2546 91.4801 97.8651 90.8367C97.9299 90.8247 97.9975 90.8136 98.0087 90.811Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 89.4219C77.5479 89.5364 78.1646 89.644 78.7842 89.7534C81.3921 90.2122 84.0029 90.6719 86.608 91.1325C86.7657 91.1607 86.8783 91.1624 87.0417 91.1333C90.1453 90.5805 93.2573 90.0302 96.3665 89.4791C96.4566 89.4629 96.5496 89.4475 96.6763 89.4261C96.6763 89.5073 96.6763 89.5782 96.6763 89.65C96.6763 89.8722 96.6735 90.0943 96.6791 90.3156C96.682 90.3583 96.6453 90.3823 96.5214 90.4045C93.3305 90.9633 90.1396 91.5238 86.9516 92.0852C86.8417 92.104 86.7685 92.1031 86.6615 92.0843C83.465 91.5281 80.2656 90.9727 77.0691 90.4156C76.9959 90.4028 76.9057 90.3729 76.9057 90.3515C76.8945 90.0456 76.8973 89.7397 76.8973 89.4219Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 89.391C83.3808 88.9151 86.0619 88.4435 88.7769 87.9658C88.7853 87.9991 88.7966 88.0231 88.7994 88.047C88.8163 88.2384 88.8388 88.4298 88.8445 88.622C88.8445 88.646 88.7853 88.6801 88.7177 88.6921C86.7491 89.0407 84.7777 89.3868 82.8063 89.7319C82.7443 89.7422 82.6345 89.7473 82.581 89.7379C81.9473 89.6251 81.3249 89.5098 80.6743 89.391Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 89.1875C90.0807 89.4225 90.0835 89.6395 90.075 89.8565C90.075 89.8762 90.0074 89.9027 89.9455 89.9138C88.9288 90.0941 87.9093 90.2718 86.887 90.4495C86.8363 90.4589 86.7433 90.4649 86.7011 90.4572C86.0618 90.3461 85.4281 90.2316 84.7578 90.112C86.5349 89.8036 88.281 89.5002 90.0807 89.1875Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 95.9995C99.475 95.9995 109.772 92.4642 109.772 88.1034V82.8962H63.7725V88.1034C63.7725 92.4642 74.0699 95.9995 86.7725 95.9995Z",
    fill: "url(#paint14_radial_2_4882)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 90.7924C99.475 90.7924 109.772 87.2571 109.772 82.8961C109.772 78.5351 99.475 74.9998 86.7725 74.9998C74.0699 74.9998 63.7725 78.5351 63.7725 82.8961C63.7725 87.2571 74.0699 90.7924 86.7725 90.7924Z",
    fill: "url(#paint15_linear_2_4882)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 82.8958C105.921 83.738 105.423 84.5625 104.469 85.3344C103.515 86.1061 102.123 86.8095 100.386 87.4042C96.9117 88.5929 92.099 89.3319 86.7728 89.3319C81.4467 89.3319 76.6339 88.5929 73.1601 87.4042C71.4224 86.8095 70.0305 86.1061 69.0766 85.3344C68.1225 84.5625 67.6245 83.738 67.6245 82.8958C67.6245 82.0535 68.1225 81.229 69.0766 80.4571C70.0305 79.6854 71.4224 78.982 73.1601 78.3873C76.6339 77.1986 81.4467 76.4597 86.7728 76.4597C92.099 76.4597 96.9117 77.1988 100.386 78.3876C102.123 78.9822 103.515 79.6856 104.469 80.4573C105.423 81.2294 105.921 82.0536 105.921 82.896V82.8958Z",
    stroke: "url(#paint16_linear_2_4882)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 82.811C98.7212 83.0161 99.4141 83.2152 100.121 83.4194C100.028 83.4382 99.9745 83.4502 99.9182 83.4596C95.5979 84.214 91.2749 84.9676 86.9546 85.723C86.8335 85.7443 86.7462 85.7477 86.6223 85.7255C82.2936 84.9668 77.9593 84.2089 73.6278 83.4502C73.5827 83.4425 73.5377 83.4339 73.4307 83.4134C73.6053 83.3664 73.7658 83.3271 73.9123 83.2835C74.3488 83.152 74.7853 83.0195 75.2106 82.8845C75.3317 82.8461 75.419 82.8418 75.5767 82.8691C79.2379 83.5031 82.9048 84.1346 86.566 84.7686C86.7434 84.7993 86.8645 84.7985 87.0391 84.7677C90.644 84.1226 94.2546 83.4801 97.8651 82.8367C97.9299 82.8247 97.9975 82.8136 98.0087 82.811Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 81.4219C77.5479 81.5364 78.1646 81.644 78.7842 81.7534C81.3921 82.2122 84.0029 82.6719 86.608 83.1325C86.7657 83.1607 86.8783 83.1624 87.0417 83.1333C90.1453 82.5805 93.2573 82.0302 96.3665 81.4791C96.4566 81.4629 96.5496 81.4475 96.6763 81.4261C96.6763 81.5073 96.6763 81.5782 96.6763 81.65C96.6763 81.8722 96.6735 82.0943 96.6791 82.3156C96.682 82.3583 96.6453 82.3823 96.5214 82.4045C93.3305 82.9633 90.1396 83.5238 86.9516 84.0852C86.8417 84.104 86.7685 84.1031 86.6615 84.0843C83.465 83.5281 80.2656 82.9727 77.0691 82.4156C76.9959 82.4028 76.9057 82.3729 76.9057 82.3515C76.8945 82.0456 76.8973 81.7397 76.8973 81.4219Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 81.391C83.3808 80.9151 86.0619 80.4435 88.7769 79.9658C88.7853 79.9991 88.7966 80.0231 88.7994 80.047C88.8163 80.2384 88.8388 80.4298 88.8445 80.622C88.8445 80.646 88.7853 80.6801 88.7177 80.6921C86.7491 81.0407 84.7777 81.3868 82.8063 81.7319C82.7443 81.7422 82.6345 81.7473 82.581 81.7379C81.9473 81.6251 81.3249 81.5098 80.6743 81.391Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 81.1875C90.0807 81.4225 90.0835 81.6395 90.075 81.8565C90.075 81.8762 90.0074 81.9027 89.9455 81.9138C88.9288 82.0941 87.9093 82.2718 86.887 82.4495C86.8363 82.4589 86.7433 82.4649 86.7011 82.4572C86.0618 82.3461 85.4281 82.2316 84.7578 82.112C86.5349 81.8036 88.281 81.5002 90.0807 81.1875Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 87.9995C99.475 87.9995 109.772 84.4642 109.772 80.1034V74.8962H63.7725V80.1034C63.7725 84.4642 74.0699 87.9995 86.7725 87.9995Z",
    fill: "url(#paint17_radial_2_4882)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 82.7924C99.475 82.7924 109.772 79.2571 109.772 74.8961C109.772 70.5351 99.475 66.9998 86.7725 66.9998C74.0699 66.9998 63.7725 70.5351 63.7725 74.8961C63.7725 79.2571 74.0699 82.7924 86.7725 82.7924Z",
    fill: "url(#paint18_linear_2_4882)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 74.8958C105.921 75.738 105.423 76.5625 104.469 77.3344C103.515 78.1061 102.123 78.8095 100.386 79.4042C96.9117 80.5929 92.099 81.3319 86.7728 81.3319C81.4467 81.3319 76.6339 80.5929 73.1601 79.4042C71.4224 78.8095 70.0305 78.1061 69.0766 77.3344C68.1225 76.5625 67.6245 75.738 67.6245 74.8958C67.6245 74.0535 68.1225 73.229 69.0766 72.4571C70.0305 71.6854 71.4224 70.982 73.1601 70.3873C76.6339 69.1986 81.4467 68.4597 86.7728 68.4597C92.099 68.4597 96.9117 69.1988 100.386 70.3876C102.123 70.9822 103.515 71.6856 104.469 72.4573C105.423 73.2294 105.921 74.0536 105.921 74.896V74.8958Z",
    stroke: "url(#paint19_linear_2_4882)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 74.811C98.7212 75.0161 99.4141 75.2152 100.121 75.4194C100.028 75.4382 99.9745 75.4502 99.9182 75.4596C95.5979 76.214 91.2749 76.9676 86.9546 77.723C86.8335 77.7443 86.7462 77.7477 86.6223 77.7255C82.2936 76.9668 77.9593 76.2089 73.6278 75.4502C73.5827 75.4425 73.5377 75.4339 73.4307 75.4134C73.6053 75.3664 73.7658 75.3271 73.9123 75.2835C74.3488 75.152 74.7853 75.0195 75.2106 74.8845C75.3317 74.8461 75.419 74.8418 75.5767 74.8691C79.2379 75.5031 82.9048 76.1346 86.566 76.7686C86.7434 76.7993 86.8645 76.7985 87.0391 76.7677C90.644 76.1226 94.2546 75.4801 97.8651 74.8367C97.9299 74.8247 97.9975 74.8136 98.0087 74.811Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 73.4219C77.5479 73.5364 78.1646 73.644 78.7842 73.7534C81.3921 74.2122 84.0029 74.6719 86.608 75.1325C86.7657 75.1607 86.8783 75.1624 87.0417 75.1333C90.1453 74.5805 93.2573 74.0302 96.3665 73.4791C96.4566 73.4629 96.5496 73.4475 96.6763 73.4261C96.6763 73.5073 96.6763 73.5782 96.6763 73.65C96.6763 73.8722 96.6735 74.0943 96.6791 74.3156C96.682 74.3583 96.6453 74.3823 96.5214 74.4045C93.3305 74.9633 90.1396 75.5238 86.9516 76.0852C86.8417 76.104 86.7685 76.1031 86.6615 76.0843C83.465 75.5281 80.2656 74.9727 77.0691 74.4156C76.9959 74.4028 76.9057 74.3729 76.9057 74.3515C76.8945 74.0456 76.8973 73.7397 76.8973 73.4219Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 73.391C83.3808 72.9151 86.0619 72.4435 88.7769 71.9658C88.7853 71.9991 88.7966 72.0231 88.7994 72.047C88.8163 72.2384 88.8388 72.4298 88.8445 72.622C88.8445 72.646 88.7853 72.6801 88.7177 72.6921C86.7491 73.0407 84.7777 73.3868 82.8063 73.7319C82.7443 73.7422 82.6345 73.7473 82.581 73.7379C81.9473 73.6251 81.3249 73.5098 80.6743 73.391Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 73.1875C90.0807 73.4225 90.0835 73.6395 90.075 73.8565C90.075 73.8762 90.0074 73.9027 89.9455 73.9138C88.9288 74.0941 87.9093 74.2718 86.887 74.4495C86.8363 74.4589 86.7433 74.4649 86.7011 74.4572C86.0618 74.3461 85.4281 74.2316 84.7578 74.112C86.5349 73.8036 88.281 73.5002 90.0807 73.1875Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 79.9995C99.475 79.9995 109.772 76.4642 109.772 72.1034V66.8962H63.7725V72.1034C63.7725 76.4642 74.0699 79.9995 86.7725 79.9995Z",
    fill: "url(#paint20_radial_2_4882)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 74.7924C99.475 74.7924 109.772 71.2571 109.772 66.8961C109.772 62.5351 99.475 58.9998 86.7725 58.9998C74.0699 58.9998 63.7725 62.5351 63.7725 66.8961C63.7725 71.2571 74.0699 74.7924 86.7725 74.7924Z",
    fill: "url(#paint21_linear_2_4882)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 66.8958C105.921 67.738 105.423 68.5625 104.469 69.3344C103.515 70.1061 102.123 70.8095 100.386 71.4042C96.9117 72.5929 92.099 73.3319 86.7728 73.3319C81.4467 73.3319 76.6339 72.5929 73.1601 71.4042C71.4224 70.8095 70.0305 70.1061 69.0766 69.3344C68.1225 68.5625 67.6245 67.738 67.6245 66.8958C67.6245 66.0535 68.1225 65.229 69.0766 64.4571C70.0305 63.6854 71.4224 62.982 73.1601 62.3873C76.6339 61.1986 81.4467 60.4597 86.7728 60.4597C92.099 60.4597 96.9117 61.1988 100.386 62.3876C102.123 62.9822 103.515 63.6856 104.469 64.4573C105.423 65.2294 105.921 66.0536 105.921 66.896V66.8958Z",
    stroke: "url(#paint22_linear_2_4882)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 66.811C98.7212 67.0161 99.4141 67.2152 100.121 67.4194C100.028 67.4382 99.9745 67.4502 99.9182 67.4596C95.5979 68.214 91.2749 68.9676 86.9546 69.723C86.8335 69.7443 86.7462 69.7477 86.6223 69.7255C82.2936 68.9668 77.9593 68.2089 73.6278 67.4502C73.5827 67.4425 73.5377 67.4339 73.4307 67.4134C73.6053 67.3664 73.7658 67.3271 73.9123 67.2835C74.3488 67.152 74.7853 67.0195 75.2106 66.8845C75.3317 66.8461 75.419 66.8418 75.5767 66.8691C79.2379 67.5031 82.9048 68.1346 86.566 68.7686C86.7434 68.7993 86.8645 68.7985 87.0391 68.7677C90.644 68.1226 94.2546 67.4801 97.8651 66.8367C97.9299 66.8247 97.9975 66.8136 98.0087 66.811Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 65.4219C77.5479 65.5364 78.1646 65.644 78.7842 65.7534C81.3921 66.2122 84.0029 66.6719 86.608 67.1325C86.7657 67.1607 86.8783 67.1624 87.0417 67.1333C90.1453 66.5805 93.2573 66.0302 96.3665 65.4791C96.4566 65.4629 96.5496 65.4475 96.6763 65.4261C96.6763 65.5073 96.6763 65.5782 96.6763 65.65C96.6763 65.8722 96.6735 66.0943 96.6791 66.3156C96.682 66.3583 96.6453 66.3823 96.5214 66.4045C93.3305 66.9633 90.1396 67.5238 86.9516 68.0852C86.8417 68.104 86.7685 68.1031 86.6615 68.0843C83.465 67.5281 80.2656 66.9727 77.0691 66.4156C76.9959 66.4028 76.9057 66.3729 76.9057 66.3515C76.8945 66.0456 76.8973 65.7397 76.8973 65.4219Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 65.391C83.3808 64.9151 86.0619 64.4435 88.7769 63.9658C88.7853 63.9991 88.7966 64.0231 88.7994 64.047C88.8163 64.2384 88.8388 64.4298 88.8445 64.622C88.8445 64.646 88.7853 64.6801 88.7177 64.6921C86.7491 65.0407 84.7777 65.3868 82.8063 65.7319C82.7443 65.7422 82.6345 65.7473 82.581 65.7379C81.9473 65.6251 81.3249 65.5098 80.6743 65.391Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 65.1875C90.0807 65.4225 90.0835 65.6395 90.075 65.8565C90.075 65.8762 90.0074 65.9027 89.9455 65.9138C88.9288 66.0941 87.9093 66.2718 86.887 66.4495C86.8363 66.4589 86.7433 66.4649 86.7011 66.4572C86.0618 66.3461 85.4281 66.2316 84.7578 66.112C86.5349 65.8036 88.281 65.5002 90.0807 65.1875Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 71.9995C99.475 71.9995 109.772 68.4642 109.772 64.1034V58.8962L63.7725 58.8962V64.1034C63.7725 68.4642 74.0699 71.9995 86.7725 71.9995Z",
    fill: "url(#paint23_radial_2_4882)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddi_2_4882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7725 66.7924C99.475 66.7924 109.772 63.2571 109.772 58.8961C109.772 54.5351 99.475 50.9998 86.7725 50.9998C74.0699 50.9998 63.7725 54.5351 63.7725 58.8961C63.7725 63.2571 74.0699 66.7924 86.7725 66.7924Z",
    fill: "url(#paint24_linear_2_4882)"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.921 58.8958C105.921 59.738 105.423 60.5625 104.469 61.3344C103.515 62.1061 102.123 62.8095 100.386 63.4042C96.9117 64.5929 92.099 65.3319 86.7728 65.3319C81.4467 65.3319 76.6339 64.5929 73.1601 63.4042C71.4224 62.8095 70.0305 62.1061 69.0766 61.3344C68.1225 60.5625 67.6245 59.738 67.6245 58.8958C67.6245 58.0535 68.1225 57.229 69.0766 56.4571C70.0305 55.6854 71.4224 54.982 73.1601 54.3873C76.6339 53.1986 81.4467 52.4597 86.7728 52.4597C92.099 52.4597 96.9117 53.1988 100.386 54.3876C102.123 54.9822 103.515 55.6856 104.469 56.4573C105.423 57.2294 105.921 58.0536 105.921 58.896V58.8958Z",
    stroke: "url(#paint25_linear_2_4882)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0087 58.811C98.7212 59.0161 99.4141 59.2152 100.121 59.4194C100.028 59.4382 99.9745 59.4502 99.9182 59.4596C95.5979 60.214 91.2749 60.9676 86.9546 61.723C86.8335 61.7443 86.7462 61.7477 86.6223 61.7255C82.2936 60.9668 77.9593 60.2089 73.6278 59.4502C73.5827 59.4425 73.5377 59.4339 73.4307 59.4134C73.6053 59.3664 73.7658 59.3271 73.9123 59.2835C74.3488 59.152 74.7853 59.0195 75.2106 58.8845C75.3317 58.8461 75.419 58.8418 75.5767 58.8691C79.2379 59.5031 82.9048 60.1346 86.566 60.7686C86.7434 60.7993 86.8645 60.7985 87.0391 60.7677C90.644 60.1226 94.2546 59.4801 97.8651 58.8367C97.9299 58.8247 97.9975 58.8136 98.0087 58.811Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8973 57.4219C77.5479 57.5364 78.1646 57.644 78.7842 57.7534C81.3921 58.2122 84.0029 58.6719 86.608 59.1325C86.7657 59.1607 86.8783 59.1624 87.0417 59.1333C90.1453 58.5805 93.2573 58.0302 96.3665 57.4791C96.4566 57.4629 96.5496 57.4475 96.6763 57.4261C96.6763 57.5073 96.6763 57.5782 96.6763 57.65C96.6763 57.8722 96.6735 58.0943 96.6791 58.3156C96.682 58.3583 96.6453 58.3823 96.5214 58.4045C93.3305 58.9633 90.1396 59.5238 86.9516 60.0852C86.8417 60.104 86.7685 60.1031 86.6615 60.0843C83.465 59.5281 80.2656 58.9727 77.0691 58.4156C76.9959 58.4028 76.9057 58.3729 76.9057 58.3515C76.8945 58.0456 76.8973 57.7397 76.8973 57.4219Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6743 57.391C83.3808 56.9151 86.0619 56.4435 88.7769 55.9658C88.7853 55.9991 88.7966 56.0231 88.7994 56.047C88.8163 56.2384 88.8388 56.4298 88.8445 56.622C88.8445 56.646 88.7853 56.6801 88.7177 56.6921C86.7491 57.0407 84.7777 57.3868 82.8063 57.7319C82.7443 57.7422 82.6345 57.7473 82.581 57.7379C81.9473 57.6251 81.3249 57.5098 80.6743 57.391Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0807 57.1875C90.0807 57.4225 90.0835 57.6395 90.075 57.8565C90.075 57.8762 90.0074 57.9027 89.9455 57.9138C88.9288 58.0941 87.9093 58.2718 86.887 58.4495C86.8363 58.4589 86.7433 58.4649 86.7011 58.4572C86.0618 58.3461 85.4281 58.2316 84.7578 58.112C86.5349 57.8036 88.281 57.5002 90.0807 57.1875Z",
    fill: "white"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1326 47.9196C93.6111 40.7102 87.255 19.9437 63 17.6498",
    stroke: "url(#paint26_linear_2_4882)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_4882",
    x: 17.2412,
    y: 5.42847,
    width: 93.8071,
    height: 93.8073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_2_4882",
    x: 0,
    y: 0,
    width: 65,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4882",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_2_4882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2_4882",
    x: 49.7725,
    y: 104.896,
    width: 74,
    height: 41.1033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddi_2_4882",
    x: 30.7725,
    y: 4.99976,
    width: 112,
    height: 81.7926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.404167 0 0 0 0 0.741154 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4882"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.858
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.858
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_4882",
    result: "effect2_dropShadow_2_4882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_4882",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.858
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.674
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925 0 0 0 0 0.936947 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2_4882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4882",
    x1: 105.108,
    y1: 122.139,
    x2: -14.8289,
    y2: -62.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5 49) rotate(-58.1915) scale(50.4781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF89E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#92D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991368,
    stopColor: "#89A7FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 121.074) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_4882",
    x1: 87.312,
    y1: 105.221,
    x2: 87.0575,
    y2: 124.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_4882",
    x1: 67.4192,
    y1: 108.273,
    x2: 106.92,
    y2: 118.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 113.074) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_4882",
    x1: 87.312,
    y1: 97.2214,
    x2: 87.0575,
    y2: 116.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_4882",
    x1: 67.4192,
    y1: 100.273,
    x2: 106.92,
    y2: 110.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 105.074) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_4882",
    x1: 87.312,
    y1: 89.2214,
    x2: 87.0575,
    y2: 108.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_4882",
    x1: 67.4192,
    y1: 92.273,
    x2: 106.92,
    y2: 102.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 97.0735) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_4882",
    x1: 87.312,
    y1: 81.2214,
    x2: 87.0575,
    y2: 100.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_4882",
    x1: 67.4192,
    y1: 84.273,
    x2: 106.92,
    y2: 94.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 89.0735) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_4882",
    x1: 87.312,
    y1: 73.2214,
    x2: 87.0575,
    y2: 92.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_4882",
    x1: 67.4192,
    y1: 76.273,
    x2: 106.92,
    y2: 86.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 81.0735) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_4882",
    x1: 87.312,
    y1: 65.2214,
    x2: 87.0575,
    y2: 84.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_4882",
    x1: 67.4192,
    y1: 68.273,
    x2: 106.92,
    y2: 78.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 73.0735) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_4882",
    x1: 87.312,
    y1: 57.2214,
    x2: 87.0575,
    y2: 76.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_4882",
    x1: 67.4192,
    y1: 60.273,
    x2: 106.92,
    y2: 70.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2_4882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7691 65.0735) rotate(68.4178) scale(14.475 25.9859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#829ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_4882",
    x1: 87.312,
    y1: 49.2214,
    x2: 87.0575,
    y2: 68.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_4882",
    x1: 67.4192,
    y1: 52.273,
    x2: 106.92,
    y2: 62.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_4882",
    x1: 37.0247,
    y1: -31.2005,
    x2: 27.4066,
    y2: 38.7448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.557292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B4DF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmmIcon);
export default __webpack_public_path__ + "static/media/amm-icon.0f5909d31e32b34b51774ede850abca8.svg";
export { ForwardRef as ReactComponent };